module.exports = __webpack_public_path__ + "static/media/flipping.55ffea83.mp4";